"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import totpmodel from "@/utils/totp";
let CheckTOTPCode = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.totp_second = 30;
    this.totp_code = null;
    this.totp_interval = null;
    this.totp_core_code = null;
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  timerToPassword() {
    return __async(this, null, function* () {
      const that = this;
      this.totp_interval = setInterval(function() {
        return __async(this, null, function* () {
          const d = new Date().getSeconds();
          that.totp_second--;
          if (that.totp_second <= 0) {
            that.totp_second = 30;
            that.getPassword();
          }
        });
      }, 1e3);
    });
  }
  getPassword() {
    return __async(this, null, function* () {
      this.totp_core_code = totpmodel.getToken(this.totp_code.secret, {
        digits: 6,
        algoritnm: "SHA-1",
        period: 30
      });
    });
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        this.totp_second = 30;
        this.totp_code = data;
        yield this.getPassword();
        this.timerToPassword();
        this.dialog.visible = true;
      } catch (error) {
        this.$message.error(this.$t("check_totp_code.get_code_error"));
      }
    });
  }
  copyCode() {
    this.$copyText(this.totp_core_code).then((e) => {
      this.$message.success(this.$t("main.copy_successful"));
    }, (e) => {
      this.$message.error(this.$t("main.copy_error"));
      console.log(e);
    });
  }
  close() {
    this.dialog.visible = false;
    if (this.totp_interval !== null) {
      clearInterval(this.totp_interval);
    }
    this.totp_interval = null;
  }
};
__decorateClass([
  Ref("checkTotpCode")
], CheckTOTPCode.prototype, "_check_totp_code", 2);
CheckTOTPCode = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], CheckTOTPCode);
export {
  CheckTOTPCode as default
};
